import { useQuery } from '@tanstack/react-query';
import { apiHelpers, parseApiResponse } from '@/api/core';

export interface KeyCategory {
  prefix: string;
  label: string;
  count: number;
  keys: string[];
}

export interface RedisHealthInfo {
  connected: boolean;
  uptime_seconds: number;
  used_memory_human: string;
  used_memory_peak_human: string;
  connected_clients: number;
  total_keys: number;
  version: string;
  keys_by_category: KeyCategory[];
}

export interface DeviceRedisInfo {
  serial_number: string;
  device_type: string | null;
  status: string;
  site_name: string | null;
  is_online: boolean;
  last_seen: string | null;
  ttl_seconds: number;
  explicit_disconnect: boolean;
  db_is_connected: boolean;
  synced: boolean;
}

export interface SystemStatusResponse {
  redis: RedisHealthInfo;
  devices: {
    total_registered: number;
    online_count: number;
    offline_count: number;
    explicit_disconnected_count: number;
    mismatch_count: number;
    list: DeviceRedisInfo[];
  };
}

export const systemStatusKeys = {
  all: ['systemStatus'] as const,
};

export function useSystemStatus() {
  return useQuery({
    queryKey: systemStatusKeys.all,
    queryFn: async (): Promise<SystemStatusResponse> => {
      const res = await apiHelpers.get<SystemStatusResponse>('systemStatus.get');
      const parsed = parseApiResponse<SystemStatusResponse>(res);
      if (parsed.error) {
        throw new Error(parsed.error.message || 'Unknown error');
      }
      return parsed.data!;
    },
    refetchInterval: 10000,
  });
}
